import React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';
import '../../styles/lot63v.css';

// LOT 63 · V9 · saisies communes à toutes les feuilles de réglages : montants séparés des milliers + devise, curseurs
const pct = (v) => String(Math.round(Number(v) * 10) / 10).replace('.', ',');
export const brut = (txt) => { const t = String(txt ?? '').replace(/[\s\u202f\u00a0]/g, '').replace(/[^\d,.]/g, '').replace('.', ','); const [e, ...d] = t.split(','); return d.length ? `${e},${d.join('').slice(0, 2)}` : e; };
export const versNombre = (txt) => { const t = brut(txt).replace(',', '.'); return t === '' ? null : Number(t); };
export const milliers = (txt) => { const t = brut(txt); if (!t) return ''; const [e, d] = t.split(','); const ent = (e || '0').replace(/^0+(?=\d)/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' '); return d != null ? `${ent},${d}` : ent; };

export const ChampMontant = ({ value, onChange, devise = 'MAD', suffixe = 'HT', placeholder = '—', testId, label }) => (
  <label className="ob63-mt">
    <input inputMode="decimal" value={milliers(String(value ?? '').replace('.', ','))} placeholder={placeholder} aria-label={label} onChange={(e) => onChange(brut(e.target.value).replace(',', '.'))} data-testid={testId} />
    <small>{[devise, suffixe].filter(Boolean).join(' ')}</small>
  </label>
);

const Poignees = ({ label, n }) => Array.from({ length: n }, (_, i) => <SliderPrimitive.Thumb key={i} className="ob63-thumb" aria-label={n > 1 ? `${label} ${i ? 'maximum' : 'minimum'}` : label} />);

export const Curseur = ({ label, value, onChange, min = 0, max = 100, step = 1, unite = '%', sous, testId }) => (
  <div className="ob63-l" data-testid={testId}>
    <div className="ob63-t"><b>{label}</b><strong data-testid={`${testId}-valeur`}>{pct(value)} {unite}</strong></div>
    <SliderPrimitive.Root className="ob63-slider" min={min} max={max} step={step} value={[Number(value)]} onValueChange={([a]) => onChange(a)} aria-label={label}>
      <SliderPrimitive.Track className="ob63-track"><SliderPrimitive.Range className="ob63-range" /></SliderPrimitive.Track>
      <Poignees label={label} n={1} />
    </SliderPrimitive.Root>
    {sous && <p className="ob63-c">{sous}</p>}
  </div>
);

export const Fourchette = ({ label, v, onChange, sous, max = 60, testId, onRetirer }) => (
  <div className="ob63-l" data-testid={testId}>
    <div className="ob63-t"><b>{label}</b><strong data-testid={`${testId}-valeur`}>{pct(v.min)} – {pct(v.max)} %</strong></div>
    <SliderPrimitive.Root className="ob63-slider" min={0} max={max} step={0.5} minStepsBetweenThumbs={1} value={[v.min, v.max]} onValueChange={([a, b]) => onChange({ min: a, max: b })} aria-label={label}>
      <SliderPrimitive.Track className="ob63-track"><SliderPrimitive.Range className="ob63-range" /></SliderPrimitive.Track>
      <SliderPrimitive.Thumb className="ob63-thumb" aria-label={`${label} minimum`} data-testid={`${testId}-min`} />
      <SliderPrimitive.Thumb className="ob63-thumb" aria-label={`${label} maximum`} data-testid={`${testId}-max`} />
    </SliderPrimitive.Root>
    {onRetirer && <button type="button" className="ob63-retirer" onClick={onRetirer} data-testid={`${testId}-retirer`}>Retirer cet objectif</button>}
    {sous && <p className="ob63-c">{sous}</p>}
  </div>
);
